import { DB } from "./db";

async function computeSessionHash(userData) {
  const payload = `${userData.discordId}:${userData.role}:${userData.name}`;
  try {
    const data = new TextEncoder().encode(payload);
    const buf = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch {
    let h1 = 0xdeadbeef,
      h2 = 0x41c6ce57;
    for (let i = 0; i < payload.length; i++) {
      const c = payload.charCodeAt(i);
      h1 = Math.imul(h1 ^ c, 2654435761);
      h2 = Math.imul(h2 ^ c, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h2 = Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    return ((h1 ^ h2) >>> 0).toString(36) + ((h2 ^ h1) >>> 0).toString(36);
  }
}

async function createSecureSession(userData, jwt) {
  const { _jwt, ...profileWithoutJwt } = userData;
  const hashVal = await computeSessionHash(profileWithoutJwt);
  const sessionData = { ...profileWithoutJwt, _h: hashVal, _t: Date.now() };
  localStorage.setItem("nt_user", JSON.stringify(sessionData));
  if (jwt) DB.setToken(jwt);
  return sessionData;
}

function validateSession(stored) {
  if (!stored || !stored._h || !stored.discordId || !stored.role) return null;
  return stored;
}

/**
 * Validates session by recomputing the integrity hash and comparing with stored _h.
 * Use on app start to detect tampering.
 */
async function validateSessionWithHash(stored) {
  if (!stored || !stored._h || !stored.discordId || !stored.role) return null;
  const { _h, _t, ...profile } = stored;
  const computed = await computeSessionHash(profile);
  if (computed !== _h) return null;
  return stored;
}

/**
 * Returns the current user from localStorage if valid, or null.
 * Hides localStorage details from the rest of the app.
 * Optionally re-validates hash (async) for stronger tamper detection.
 */
function getCurrentUser() {
  try {
    const raw = localStorage.getItem("nt_user");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return validateSession(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export { computeSessionHash, createSecureSession, validateSession, validateSessionWithHash, getCurrentUser };

